import { Component, OnInit, OnDestroy } from '@angular/core';

import { NetworkService } from '../../../core/service/network/network.service';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'layouts-no-has-internet',
  standalone: true,
  imports: [],
  templateUrl: './no-has-internet.component.html',
  animations: [
    trigger('fadeIn', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ])
    ]),
    trigger('pulse', [
      transition('* => *', [
        animate('1000ms', keyframes([
          style({ transform: 'scale(1)', offset: 0 }),
          style({ transform: 'scale(1.05)', offset: 0.5 }),
          style({ transform: 'scale(1)', offset: 1 })
        ]))
      ])
    ])
  ]
})
export class NoHasInternetComponent implements OnInit, OnDestroy {
  isOnline: boolean = true;
  pulseState: string = 'pulse';
  private networkSubscription: Subscription = new Subscription();
  private pulseInterval: any;

  constructor(private networkService: NetworkService) {}

  ngOnInit(): void {
    this.isOnline = this.networkService.getCurrentStatus();
    this.networkSubscription = this.networkService.getNetworkStatus().subscribe(status => {
      this.isOnline = status;
      if (!this.isOnline) {
        // Solo iniciamos el pulso si estamos offline
        this.startPulseAnimation();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.networkSubscription) {
      this.networkSubscription.unsubscribe();
    }

    if (this.pulseInterval) {
      clearInterval(this.pulseInterval);
    }
  }

  startPulseAnimation(): void {
    if (this.pulseInterval) {
      clearInterval(this.pulseInterval);
    }
    this.pulseState = 'pulse';
    this.pulseInterval = setInterval(() => {
      this.pulseState = this.pulseState === 'pulse' ? 'noPulse' : 'pulse';
    }, 2000);
  }

  tryReconnect(): void {
    window.location.reload();
  }
}
